module.exports = __webpack_public_path__ + "img/vitte.e342fa82.png";